import React from 'react';

const TextStep = ({ formData, handleInputChange }) => {
    return (
        <div className="space-y-4 md:space-y-6 -mt-4">

            <div>
                <h3 className="text-[31px] font-light mb-4">Make It Personal</h3>
                <p className="mb-8 text-gray-300 text-md">
                Give your star map a personal touch with a custom title and footnote. Add a heartfelt message, a favorite quote, or simply the name of the moment. Whether it’s "The Night We Met", "When You Were Born", or "Under Our Stars", your words make the map even more meaningful.                </p>
            </div>

            <div className="border-t border-dotted border-[#A0A0A0] !mt-10 !mb-10"></div>

            <div className="form-group">
                <label className="block mb-1 sm:mb-2 font-medium text-md">Personal Message</label>
                <div className="relative">
                    <textarea
                        name="caption"
                        value={formData.caption}
                        onChange={handleInputChange}
                        placeholder="Add a meaningful message..."
                        className="w-full p-2 sm:p-3 pl-8 sm:pl-10 pr-8 sm:pr-10 rounded-[10px] border !border-white !bg-black focus:outline-none min-h-[170px] sm:min-h-[200px] text-md sm:text-base"
                    ></textarea>
                    <span className="absolute left-2 sm:left-3 !top-4 sm:top-3 text-white">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" className="sm:w-[18px] sm:h-[18px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                        </svg>
                    </span>
                </div>
            </div>

            <div className="form-group hidden">
                <label className="block mb-1 sm:mb-2 font-medium">Text Style</label>
                <div className="grid grid-cols-2 gap-2 sm:grid-cols-4 sm:gap-4">
                    {['classic', 'modern', 'script', 'minimalist'].map((style) => (
                        <div
                            key={style}
                            className={`relative cursor-pointer rounded-lg p-2 sm:p-3 text-center border ${formData.textStyle === style ? 'boπrder-accent bg-primary/40 shadow-lg' : 'border-secondary bg-lightBg/50 hover:bg-primary/20'}`}
                            onClick={() => handleInputChange({ target: { name: 'textStyle', value: style } })}
                        >
                            <div className="font-medium capitalize">{style}</div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="border-t border-dotted border-[#A0A0A0] !mt-8 !mb-4"></div>
        </div>
    );
};

export default TextStep; 